import { render, staticRenderFns } from "./document-list.vue?vue&type=template&id=12924b02&scoped=true"
import script from "./document-list.vue?vue&type=script&lang=js"
export * from "./document-list.vue?vue&type=script&lang=js"
import style0 from "./document-list.vue?vue&type=style&index=0&id=12924b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12924b02",
  null
  
)

export default component.exports